/* eslint camelcase: 0 */

import {
  LkPassport as Data,
} from '@/typings/api/Passport'
import { Model, createMessages } from '@/helpers/Model'


export class LkPassportModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
  });
}
